import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-down",
  "use": "icon-down-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-down\"><defs><style type=\"text/css\"></style></defs><path d=\"M551.936 718.0288l303.104-378.88A51.2 51.2 0 0 0 815.104 256H208.896a51.2 51.2 0 0 0-39.936 83.2l303.104 378.8288a51.2 51.2 0 0 0 79.872 0z\" fill=\"#d81e06\" p-id=\"1990\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol